//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './VersionClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export function versionUrl(): string {
  let url_ = getBaseUrl() + "/api";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let versionDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey'> = {
  queryFn: __version,
};
export function getVersionDefaultOptions() {
  return versionDefaultOptions;
};
export function setVersionDefaultOptions(options: typeof versionDefaultOptions) {
  versionDefaultOptions = options;
}

export function versionQueryKey(): QueryKey;
export function versionQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'VersionClient',
      'version',
    ]);
}
function __version(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.version(
axiosConfig    );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function useVersionQuery<TSelectData = string, TError = unknown>(options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useVersionQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __version(context, axiosConfig) : __version,
    queryKey: versionQueryKey(),
    ...versionDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setVersionData(queryClient: QueryClient, updater: (data: string | undefined) => string, ) {
  queryClient.setQueryData(versionQueryKey(),
    updater
  );
}

/**
 * Gets the version of the service.
 * @return A string representing the version.
 */
export function setVersionDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}